import { MessageBox } from 'element-ui'
const state = {
  user: {},
  accountInfo: {},
  token: '',
  showProduct: false
}
const getters = {
  token: state => {
    return state.token
  },
  user: state => {
    return state.user
  },
  accountInfo: state => {
    return state.accountInfo
  },
  showProduct: state => {
    return state.showProduct
  }
}
const mutations = {
  set_token: (state, data) => {
    state.token = data
  },
  set_user_info: (state, data) => {
    state.user = data
  },
  set_account_info: (state, data) => {
    state.accountInfo = data
  },
  check_hs_code: (state, data) => {
    if (state.user.hsCodes) {
      let stringLength = data.length
      let right = state.user.hsCodes.find(item => {
        let codes = item.hsCodes.split(',')
        let rightCode = codes.find(c => {
          let length = Math.min(c.length, stringLength)
          return c.slice(0, length) === data.slice(0, length)
        })
        return rightCode !== undefined
      })
      return !!right
    } else {
      return true
    }
  },
  show_hs_code_error: () => {
    let url = this.$util.getCurrentWebSiteByProduct() + '/user' + `?p=${encodeURIComponent('product/gt6')}`
    MessageBox.confirm(`<p style="font-size: 12px;">提示：您所输入的HS编码超出了本账号的权限，请重新输入。您可以前往<a class="text-btn" href="${url}">账户中心</a>，查看本账户开通的HS编码行业类目；如有疑问，可联系管理员或客服咨询详情。</p>`, {
      confirmButtonText: this.$t('sure'),
      showCancelButton: false,
      confirmButtonClass: 'sub-confirm-btn',
      type: 'warning',
      dangerouslyUseHTMLString: true
    })
  },
  change_show_product: (state, data) => {
    if (data !== undefined) {
      state.showProduct = data
    } else {
      state.showProduct = !state.showProduct
    }
  }
}

export default {
  state,
  mutations,
  getters
}
